import React from "react";
import { Menu } from "lucide-react";
import { useNavigate } from "react-router-dom";

const DashboardHeader = ({
  title = "Dashboard",
  backTo = "/",
  onMenuClick, // optional: for sidebar toggle
  showMenu = false, // controls hamburger visibility
}) => {
  const navigate = useNavigate();

  return (
    <header className="w-full bg-white border-b border-blue-200 shadow-sm sticky top-0 z-40">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 lg:px-10 py-3 sm:py-4 md:py-5">
        {/* Left: Hamburger (mobile only) */}
        {showMenu ? (
          <button
            onClick={onMenuClick}
            className="text-blue-600 hover:text-blue-700 focus:outline-none lg:hidden"
          >
            <Menu size={26} />
          </button>
        ) : (
          <div className="w-6" /> // spacer for consistent alignment
        )}

        {/* Center: Title */}
        <h1 className="text-lg sm:text-2xl md:text-3xl font-bold text-blue-700 text-center flex-1 truncate">
          {title}
        </h1>

        {/* Right: Back Button */}
        <button
          onClick={() => navigate(backTo)}
          className="hidden sm:inline-block bg-blue-500 hover:bg-blue-600 text-white font-medium text-sm sm:text-base px-4 sm:px-6 py-2 rounded-lg shadow-sm hover:shadow-md transition-all"
        >
          Back to Menu
        </button>

        {/* Mobile back button (icon style) */}
        <button
          onClick={() => navigate(backTo)}
          className="sm:hidden bg-blue-500 hover:bg-blue-600 text-white text-xs font-medium px-3 py-1.5 rounded-md shadow-sm transition-all"
        >
          Back
        </button>
      </div>
    </header>
  );
};

export default DashboardHeader;
